import { STEPS } from '../../utils/routes.util';

export default BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state(STEPS.ZONE_PERTURBE, {
    url: '/zone-perturbe',
    template: '<dmattnt-zone-perturbe></dmattnt-zone-perturbe>',
    data: {label: 'Incident détecté'}
  }).state(STEPS.CONTACT, {
    url: '/contact',
    template: '<dmattnt-contact></dmattnt-contact>',
    data: {label: 'Contact'}
  }).state(STEPS.CONSTAT, {
    url: '/constat',
    template: '<dmattnt-constat></dmattnt-constat>',
    data: {label: 'Constat'}
  }).state(STEPS.FIN_ANTENNISTE, {
    url: '/fin-antenniste',
    template: '<dmattnt-fin-antenniste></dmattnt-fin-anteniste>',
    data: {label: 'À bientôt'}
  });
}



// WEBPACK FOOTER //
// ./src/modules/antenniste/routes.js